import { Component, Input } from "@angular/core";
import { AiInsight, CardState } from "../card-types";

@Component({
  selector: "ai-insights-card",
  templateUrl: "./ai-insights-card.component.html",
  styleUrls: ["../../dashboard-section.scss", "../../dashboard-section-v2.scss"],
  styles: [":host { display: contents; }"],
})
export class AiInsightsCardComponent {
  @Input() title: string;
  @Input() hint: string;
  @Input() icon: string;
  @Input() state: CardState<AiInsight>;
  @Input() noDataMessage: string = "Nothing to see here yet.";
  @Input() isReport: boolean = false;
  @Input() comingSoon: boolean = false;
  @Input() twoColumn: boolean = false;

  trackByIndex(index: number): number {
    return index;
  }
}
